import { useIoContext, useOverlayContext, useStore, useStoreActions } from "../../../contexts";
import IntegrationCard from "../IntegrationCard/IntegrationCard";
import gmailLogo from "../../../../assets/Gmail.png";
import { EmailOnBehalfTypes } from "../../../models/EmailOnBehalfSettingsModel";
import { getEmailProviderDetails, Tab } from "../../../pages/NotificationSettings/NotificationSettings.utils";
import { selectors } from "../../../store/state-selectors";
import { handleRequest } from "../../../infra/utils";
import { integrationModel } from "../../../models";
import { routes } from "../../../constants";
import { useHistory } from 'react-router';
import { Typography } from 'seagull';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default function GmailCard(_ref) {
  let {
    integration,
    isDisabled
  } = _ref;
  const businessId = useStore(selectors.user.businessId);
  const {
    api
  } = useStoreActions();
  const changeLocation = useIoContext().changeLocation;
  const {
    startLoader,
    stopLoader,
    showErrorToast
  } = useOverlayContext();
  const {
    logBI
  } = useStoreActions();
  const history = useHistory();
  const handleClick = async () => {
    const providerDetails = getEmailProviderDetails(EmailOnBehalfTypes.Gmail);
    if (integrationModel.isLinked(integration)) {
      history.push(routes.notifications, {
        selectedTab: Tab.Client
      });
      return;
    }
    logBI(providerDetails.biCodes.connect, {
      vendorId: businessId
    });
    if (businessId) {
      startLoader();
      const result = await handleRequest(api.notification.emailOnBehalf.connectEmailOnBehalf({
        businessId,
        provider: EmailOnBehalfTypes.Gmail,
        pageUrl: window.location.origin + window.location.pathname
      }));
      if (result.success) {
        changeLocation(result.data);
      } else {
        logBI(providerDetails.biCodes.authError, {
          vendorId: businessId
        });
        showErrorToast("Failed to connect gmail account - please try again", "start-gmail-flow-error-toast");
      }
      stopLoader();
    } else {
      logBI(providerDetails.biCodes.authError, {
        vendorId: businessId
      });
      showErrorToast('please refresh and try again', 'no-business-id-error-toast');
    }
  };
  return /*#__PURE__*/_jsx(IntegrationCard, {
    "data-testid": "gmail-card",
    icon: /*#__PURE__*/_jsx(IntegrationCard.LogoImg, {
      alt: "gmail logo",
      src: gmailLogo
    }),
    title: "Gmail",
    subTitle: "Send client communications through your Gmail mailbox.",
    mainAction: /*#__PURE__*/_jsx(IntegrationCard.MainActionButton, {
      onClick: handleClick,
      "data-testid": "gmail-card-connect",
      disabled: isDisabled,
      tooltip: isDisabled ? {
        placement: 'right',
        title: /*#__PURE__*/_jsxs("div", {
          "data-testid": "gmail-card-tooltip",
          children: [/*#__PURE__*/_jsx(Typography, {
            variant: "paragraph1",
            skin: "invertedStandard",
            children: "Only one mailbox can be connected at a time."
          }), /*#__PURE__*/_jsx(Typography, {
            variant: "paragraph1",
            skin: "invertedStandard",
            children: "Disconnect Outlook first to connect your Gmail mailbox."
          })]
        })
      } : undefined,
      children: integrationModel.isLinked(integration) ? 'Manage connection' : 'Connect'
    })
  });
}